import { useProductPageStore } from '../../contexts/ProductPageStore'

import React from 'react'

import { useRecommendationStore } from 'Clutch/Stores/RecommendationStore/RecommendationStore'

import RecommendationSection from 'Clutch/Organisms/RecommendationSection/RecommendationSection'

import Gutters from 'Clutch/Atoms/Gutters'

const SummaryRecommendations = () => {
  const keywords = useRecommendationStore((x) => x.keywords)
  const scrollToTopAndStartNavigation = useProductPageStore((x) => x.scrollToTopAndStartNavigation)

  return (
    <Gutters>
      <RecommendationSection
        section={'PDP_Top'}
        numberOfSkeletons={5}
        displayType={'Carousel'}
        spacingSize={'None'}
        keywords={keywords}
        nextLink
        prefetch={false}
        onClick={scrollToTopAndStartNavigation}
      />
    </Gutters>
  )
}

export default SummaryRecommendations
